import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

export const generatePDF = async (assessment: any) => {
  // Create a temporary div to render the report
  const reportContainer = document.createElement('div');
  reportContainer.style.padding = '40px';
  reportContainer.style.background = 'white';
  reportContainer.style.color = 'black';
  reportContainer.style.width = '800px';
  reportContainer.style.position = 'absolute';
  reportContainer.style.left = '-9999px';
  
  // Add report content
  reportContainer.innerHTML = `
    <div style="font-family: Arial, sans-serif;">
      <h1 style="color: #000; font-size: 24px; margin-bottom: 20px;">
        Assessment Report
      </h1>
      
      <div style="margin-bottom: 30px;">
        <p style="color: #666; font-size: 14px;">
          Generated on: ${new Date().toLocaleString()}
        </p>
      </div>

      <div style="margin-bottom: 40px;">
        <h2 style="color: #000; font-size: 20px; margin-bottom: 15px;">
          Overall Score: ${assessment.results.overallScore}%
        </h2>
        <p style="color: #666; font-size: 14px;">
          Assessment completed on: ${new Date(assessment.created_at).toLocaleString()}
        </p>
      </div>

      <div style="margin-bottom: 40px;">
        <h2 style="color: #000; font-size: 20px; margin-bottom: 15px;">
          Category Scores
        </h2>
        ${Object.entries(assessment.results.criteria)
          .map(([category, score]) => `
            <div style="margin-bottom: 15px;">
              <div style="display: flex; justify-content: space-between; margin-bottom: 5px;">
                <span style="color: #000; font-weight: bold;">${category}</span>
                <span style="color: #666;">${score}%</span>
              </div>
              <div style="background: #eee; height: 10px; border-radius: 5px;">
                <div style="background: #4F46E5; width: ${score}%; height: 100%; border-radius: 5px;"></div>
              </div>
            </div>
          `).join('')}
      </div>

      <div style="margin-bottom: 40px;">
        <h2 style="color: #000; font-size: 20px; margin-bottom: 15px;">
          Requirements Met
        </h2>
        <ul style="list-style-type: none; padding: 0;">
          ${assessment.results.matches[0].requirements.met
            .map((req: string) => `
              <li style="color: #666; margin-bottom: 10px; padding-left: 20px; position: relative;">
                <span style="color: #4F46E5; position: absolute; left: 0;">✓</span>
                ${req}
              </li>
            `).join('')}
        </ul>
      </div>

      <div style="margin-bottom: 40px;">
        <h2 style="color: #000; font-size: 20px; margin-bottom: 15px;">
          Areas for Improvement
        </h2>
        <ul style="list-style-type: none; padding: 0;">
          ${assessment.results.matches[0].requirements.missing
            .map((req: string) => `
              <li style="color: #666; margin-bottom: 10px; padding-left: 20px; position: relative;">
                <span style="color: #EF4444; position: absolute; left: 0;">•</span>
                ${req}
              </li>
            `).join('')}
        </ul>
      </div>

      <div>
        <h2 style="color: #000; font-size: 20px; margin-bottom: 15px;">
          Recommendations
        </h2>
        <ul style="list-style-type: none; padding: 0;">
          ${assessment.results.recommendations
            .map((rec: string) => `
              <li style="color: #666; margin-bottom: 10px; padding-left: 20px; position: relative;">
                <span style="color: #4F46E5; position: absolute; left: 0;">→</span>
                ${rec}
              </li>
            `).join('')}
        </ul>
      </div>
    </div>
  `;

  // Add to document, render, and remove
  document.body.appendChild(reportContainer);
  const canvas = await html2canvas(reportContainer);
  document.body.removeChild(reportContainer);

  // Create PDF
  const pdf = new jsPDF({
    format: 'a4',
    unit: 'px'
  });

  // Add content to PDF
  const imgData = canvas.toDataURL('image/png');
  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
  
  pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);

  // Return as blob
  return pdf.output('blob');
};